import React from "react";

interface WizardContentProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  stepIndex?: number;
  stepName?: string;
}

export const WizardContent: React.FC<WizardContentProps> = ({
  title,
  subtitle,
  children,
  stepIndex,
  stepName,
}) => {
  return (
    <div
      className="overflow-auto px-6 py-2 medium:py-4 tall:py-8 grid grid-cols-1 grid-rows-[auto_1fr]"
      data-wizard-content
    >
      <div className="text-center">
        <h2 className="medium:mb-2 text-2xl font-medium text-gray-800" data-wizard-step-title>
          {title}
        </h2>
        <p className="text-gray-600" data-wizard-step-subtitle>
          {subtitle}
        </p>
      </div>
      <div
        className="w-full max-w-md bg-white px-4 py-2 tall:py-4 flex flex-col justify-center justify-self-center"
        data-wizard-step-content
        data-wizard-step-index={stepIndex}
        data-wizard-step-name={stepName}
      >
        {children}
      </div>
    </div>
  );
};
